export default [
  {
    path: '/pages',
    name: 'pages.index',
    component: require('./index').default,
    meta: {
      title: '独立页面',
      navbar: 'el-icon-document',
      permission: 'pages.read'
    }
  },
  {
    path: '/pages/:id',
    name: 'pages.show',
    component: require('./show').default,
    meta: {
      title: '独立页面详情',
      permission: 'pages.read'
    }
  },
  {
    path: '/pages/:id/edit',
    name: 'pages.edit',
    component: require('./edit').default,
    meta: {
      title: '修改独立页面',
      permission: 'pages.update'
    }
  }
]
